import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import { LodgeStatus } from '../../Marker/Marker.constants';
import SVGIcon from '../../SVGIcon/SVGIcon';
import FormElements from '../../FormElements/FormElements';
import { HEADING_COLORS, colors, mixins, media, fonts } from '../../css';
import Text from '../../BuildingBlocks/Text';

const { HeadingFifth, CopyParagraph } = Text;
const { SOLD_OUT } = LodgeStatus;

export const StyledPaneHeadingText = styled(HeadingFifth)``;

export const StyledPaneCapacityText = styled(CopyParagraph)``;

export const StyledHeadingText = styled.h4`
  font-size: ${mixins.pxToRem(18)};
  font-family: ${fonts.fontBold};
  color: ${colors.colorGrey};
  letter-spacing: ${mixins.pxToRem(-0.31)};
  line-height: ${mixins.pxToRem(20)};
  margin-bottom: 5px;
`;

export const StyledCloseArrow = styled(SVGIcon)`
  position: relative;
  top: ${mixins.pxToRem(4)};
`;

export const StyledCapacityText = styled.p`
  font-size: ${mixins.pxToRem(18)};
  font-family: ${fonts.fontRegular};
  color: ${colors.colorGrey02};
  letter-spacing: ${mixins.pxToRem(-0.31)};
  line-height: ${mixins.pxToRem(28)};
`;

export const StyledAvailabilityText = styled(CopyParagraph)`
  position: absolute;
  top: -16px;
  right: 0;
  width: ${mixins.pxToRem(135)};
  font-size: ${mixins.pxToRem(12)};
  font-family: ${fonts.fontBold};
  letter-spacing: ${mixins.pxToRem(0.3)};
  line-height: ${mixins.pxToRem(15)};
  text-align: right;
  margin-top: 5px;
  margin-left: 10px;
  color: ${({ status }) => (status === SOLD_OUT ? colors.colorRed : colors.colorBlue)};
`;

export const StyledRoomCardWrapper = styled.div`
  padding: ${mixins.pxToRem(30)} ${mixins.pxToRem(32)} ${mixins.pxToRem(15)} ${mixins.pxToRem(32)};
  display: inline-block;
  width: 100%;
  background-color: ${({ status }) => (status ? colors.colorWhiteRgba(0.6) : colors.colorWhite)};
  opacity: ${({ status }) => (status ? 0.8 : 1)};
  ${media.greaterThan('md')`
    padding: ${mixins.pxToRem(20)} ${mixins.pxToRem(38)};
  `};
  ${media.greaterThan('lg')`

    padding: ${mixins.pxToRem(20)};
  `};
`;

export const StyledOpenButtonWrapper = styled.span`
  cursor: pointer;
  z-index: 10;
  position: relative;
  ${media.greaterThan('lg')`
    top: ${mixins.pxToRem(-15)};
  `};
`;

export const StyledRoomPrice = styled.h4`
  font-family: ${fonts.fontBold};
  font-size: ${props => (props.propertyPane ? `${mixins.pxToRem(14)}` : `${mixins.pxToRem(18)}`)};
  color: ${colors.colorGrey02};
  letter-spacing: 0;
  line-height: ${mixins.pxToRem(16)};
  float: left;
  margin-top: ${mixins.pxToRem(5)};
  a {
    text-decoration: none;
    color: #53b7b0;
  }
`;

export const StyledCurrencyLine = styled.p`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(14)};
  color: ${colors.colorGrey03};
  letter-spacing: 0;
  line-height: ${mixins.pxToRem(16)};
  float: left;

  padding-left: ${mixins.pxToRem(5)};
  padding-top: ${mixins.pxToRem(6)};
  padding-bottom: 0;
  && {
    margin-bottom: 0;
  }
`;

export const StyledStartingLine = styled.p`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(14)};
  color: ${colors.colorGrey03};
  letter-spacing: 0;
  line-height: ${mixins.pxToRem(16)};

  padding-top: ${mixins.pxToRem(20)};

  ${media.greaterThan('md')`
  padding-top: ${mixins.pxToRem(15)};
  `};
`;

export const StyledStrikeoutPrice = styled(CopyParagraph)`
  color: ${colors.colorRed};
  text-decoration: line-through;
  margin-left: 5px;
  font-weight: 500;
`;

export const StyledRightColumn = styled.div`
  padding-top: ${mixins.pxToRem(18)};
  float: right;
  width: ${props => (props.propertyPane ? `35%` : `25%`)};
  position: relative;
`;

export const StyledLeftColumn = styled.div`
  ${props => props.shouldDisplayCallForInfo && 'display: flex'};
  ${props => props.shouldDisplayCallForInfo && 'justify-content: space-between'};
  float: left;
  width: ${props => (props.propertyPane ? `65%` : `75%`)};
  padding-bottom: ${mixins.pxToRem(10)};
  ${props => props.shouldDisplayCallForInfo && 'width: 100%'};
`;

export const StyledNumberToggle = styled(FormElements.NumberToggle)`
  float: right;
  button[aria-label='Increase'] {
    margin-bottom: ${props => (props.propertyPane ? `${mixins.pxToRem(5)}` : `${mixins.pxToRem(10)}`)};
    width: ${props => (props.propertyPane ? `${mixins.pxToRem(20)}` : `${mixins.pxToRem(24)}`)};
    height: ${props => (props.propertyPane ? `${mixins.pxToRem(20)}` : `${mixins.pxToRem(24)}`)};
    border: 1px solid ${colors.colorGrey03};
    border-radius: 50%;
    &:before,
    &:after {
      border: 1px solid ${colors.colorGrey03};
    }
    &.disabled:before,
    &.disabled:after {
      border: 1px solid ${colors.colorGrey04};
    }
  }
  button[aria-label='Decrease'] {
    margin-top: ${props => (props.propertyPane ? `${mixins.pxToRem(5)}` : `${mixins.pxToRem(10)}`)};
    width: ${props => (props.propertyPane ? `${mixins.pxToRem(20)}` : `${mixins.pxToRem(24)}`)};
    height: ${props => (props.propertyPane ? `${mixins.pxToRem(20)}` : `${mixins.pxToRem(24)}`)};
    border: 1px solid ${colors.colorGrey03};
    border-radius: 50%;
    &:before,
    &:after {
      border: 1px solid ${colors.colorGrey03};
    }
    &.disabled:before,
    &.disabled:after {
      border: 1px solid ${colors.colorGrey04};
    }
  }
  button.disabled {
    cursor: default;
    opacity: 0;
  }
`;

export const StyledRoomDescription = styled.p`
  text-align: inherit;
  text-transform: none;
  font-family: ${fonts.fontRegular};
  font-size: ${props => (props.propertyPane ? `0.675rem` : `0.875rem`)};
  line-height: ${props => (props.propertyPane ? `1rem` : `1.5rem`)};
  color: ${colors.colorGrey};
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  font-weight: ${({ bold }) => (bold ? '600' : '400')};
`;

export const StyledRoomDescDrawer = styled.div`
  clear: both;
`;

export const StyledCollapseButton = styled.button`
  display: inline-block;
  outline: none;
  cursor: pointer;
  &.disabled {
    cursor: default;
  }
`;

export const StyledHideShowText = styled.p`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(12)};
  color: #53b7b0;
  letter-spacing: ${mixins.pxToRem(-0.21)};
  display: inline-block;
`;

export const StyledButtonRow = styled.div`
  width: 100%;
  text-align: center;
`;

export const StyledReveal = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${media.greaterThan('md')`
  flex-wrap: nowrap;
  `};
`;

export const StyledInnerLeftColumn = styled.div`
  min-width: ${mixins.pxToRem(150)};
  padding-bottom: ${mixins.pxToRem(10)};
`;

export const StyledDivider = styled.div`
  width: ${mixins.pxToRem(1)};
  min-width: ${mixins.pxToRem(1)};
  background: ${colors.colorGrey04Rgba(0.5)};
  margin: ${mixins.pxToRem(30)} ${mixins.pxToRem(10)} ${mixins.pxToRem(10)} ${mixins.pxToRem(5)};
  max-height: 100%;
  display: none;
  ${media.greaterThan('md')`
  display: block;
  `};
`;

export const StyledInnerRightColumn = styled.div`
  padding-bottom: ${mixins.pxToRem(10)};
`;
export const StyledPagination = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledArrowIcon = styled(SVGIcon)`
  vertical-align: middle;
`;

const spreadSpinner = ({ spinnerColor, ...rest }) => <CircularProgress {...rest} />;
export const StyledSpinner = styled(spreadSpinner)`
  && {
    color: ${props => HEADING_COLORS[props.spinnerColor] || colors.colorBlue};
  }
`;

export const StyledCallForPricing = styled.div`
  letter-spacing: 0;
  line-height: ${mixins.pxToRem(16)};
  float: left;
  margin-top: ${mixins.pxToRem(12)};
`;

export const CallForPricingContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
